import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menubar: []
  },
  mutations: {
    mutationsChange(state, params) {
      console.log("---------mutationsChange----------");
      console.log(state, params);
      state.menubar = params
    }
  },
  actions: {
    actionsChange(store, params) {
      store.commit('mutationsChange', params)
    }
  },
  modules: {
  }
})
